import qs, { parseUrl, parse } from 'query-string';
import { callCenterConfig, CALL_CENTER_VENDOR, debug } from '@/constants/Constants';
import { addTestLaneToUrl } from './test-lane';

// get请求计算完整的URL，通常用于添加自定义参数
export function computeGetUrl(url) {
  return addTestLaneToUrl(url);
}

// 解析列表的参数 (ptp-fe-common组件库的ListView组件规范)
export function parseListViewParams() {
  try {
    const search = parse(location.search);
    const params = JSON.parse(search.params || '{}') || {};
    // 排序字段反解析
    if (params.order_by || params.order_value) {
      params.order = {
        field: params.order_by || '',
        type: params.order_value === 'ASCENDING' ? 'ASC' : 'DESC',
      };
      delete params.order_by;
      delete params.order_value;
    }
    return params;
  } catch(e) {
    return {};
  }
}

// 包装列表参数到query
export function addListViewParamsToUrl(url, params) {
  return addParamsToUrl(url, { params: JSON.stringify(params) });
}

// 地址参数包装
export function addParamsToUrl(url, params) {
  const index = url.indexOf('?');

  let oldParams = {
    ...params,
  };
  if (index >= 0) {
    url = url.substring(0, index);
    oldParams = {
      ...parse(url.substring(index)),
      ...oldParams,
    };
  };
  // TODO: qs.stringify会有问题，将json关键词转义
  return `${url}?${qs.stringify(oldParams)}`;
}

export function isOa() {
  // woa.com不算oa域
  if (/\.oa\.com/.test(location.host)) {
    return true;
  }
  return false;
}

/**
 * @description 获取销售OA域免登录token
 */
export function getBearerToken() {
  const { query = {} } = parseUrl(location.href);

  let token = null;
  if (query.token) {
    token = query.token;
    sessionStorage.setItem('bearer_token', query.token);
  } else if (sessionStorage.getItem('bearer_token')) {
    token = sessionStorage.getItem('bearer_token');
  }

  return token;
}

export function arrayToMap(arr, key) {
  return arr.reduce((prev, curr) => {
    return {
      ...prev,
      [curr[key]]: curr,
    };
  }, {});
}

export const getQuery = (query) => {
  const search = window.location.search || window.location.href.split('?')[1];
  const queryList = parse(search);
  return queryList[query] && decodeURIComponent(queryList[query]);
};

export const handleCallCenterLabel = (key) => {
  const [filter] = (callCenterConfig || []).filter((v) => v.value === CALL_CENTER_VENDOR[key]?.key);
  return filter?.label || '';
};

export function isInIframe() {
  return !(window.self === window.top);
}

/**
 * @description: 去除+86
 */

export const handleRemove86 = (str) => {
  if (str) {
    str = `${str}`;
    if (str.startsWith('+86')) {
      return str.slice(3);
    }
    return str;
  }
  return str;
};

// 全角转化为半角
export const ToCDB = (str) => {
  let tmp = '';
  for (let i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) == 12288) {
      tmp += String.fromCharCode(str.charCodeAt(i) - 12256);
      continue;
    }
    if (str.charCodeAt(i) > 65280 && str.charCodeAt(i) < 65375) {
      tmp += String.fromCharCode(str.charCodeAt(i) - 65248);
    }
    else {
      tmp += String.fromCharCode(str.charCodeAt(i));
    }
  }
  return tmp;
};
